module.exports = __webpack_public_path__ + "img/sozai_cman_jp_20200825170154.612ee8f0.png";